module.exports = "https://coursera_assets.s3.amazonaws.com/images/c5ee723406a053a78a85bc35f5b50681.png";